import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

const PRESERVE_SCROLL_PATTERNS = [];

const shouldPreserveScrollForPath = (pathname) =>
  PRESERVE_SCROLL_PATTERNS.some((pattern) => matchPath({ path: pattern, end: true }, pathname));

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    if (shouldPreserveScrollForPath(pathname)) return;

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
